import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const useShareLinkModal = () => {
  const [shareLinkType, setShareLintType] = useState('byLink');
  const setShareLinkTypeByLink = useCallback(() => setShareLintType('byLink'), []);
  const setShareLinkTypeByEmail = useCallback(() => setShareLintType('byEmail'), []);
  const inputEl: any = useRef(null);

  const modal = useSelector<any, any>(state => state.modal);

  useEffect(() => {
    if (inputEl && inputEl.current) {
      inputEl.current.focus();
      inputEl.current.select();
    }
  });

  return { inputEl, shareLinkType, setShareLinkTypeByLink, setShareLinkTypeByEmail, modal };
};

export default useShareLinkModal;
